import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';
import { parsePrice } from '../../../../../../../lib/helper.js';
import defaultMsg from '../../../../../../../translations/lang/en-US.json';
import Discount from './Discount';

class OrderHistoryBody extends PureComponent {
  render() {
    const { subtotal, orderType, deliveryFee=0, discountDetails } = this.props;
    return (
      <ul className="list-style">
        <li>
          <FormattedMessage
            id="itemsSubtotal"
            defaultMessage={defaultMsg.itemsSubtotal} />
          <span className="pull-right">
            {parsePrice(subtotal)}
          </span>
        </li>
        {orderType === 'delivery' ? (
        <li>
          <FormattedMessage
            id="deliveryFees"
            defaultMessage={defaultMsg.deliveryFees} />
          <span className="pull-right">
            {parsePrice(deliveryFee)}
          </span>
        </li>
        ) : null}
        {get(discountDetails, 'discountValue', 0).toString().replace(/[0\.,\t\s]/g, '').length > 0 ? 
          <Discount discountDetails={discountDetails} /> : 
          null
        }
      </ul>
    );
  }
}

export default OrderHistoryBody;


// WEBPACK FOOTER //
// ./src/views/CustomerOrderHistory/components/OrderHistoryPanel/OrderHistoryBody/ReceiptDetails/SubTotal/index.jsx